import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-228b83b0")

_pushScopeId("data-v-228b83b0")
const _hoisted_1 = { class: "ui__RatingCriteria_main" }
const _hoisted_2 = { class: "ui__RatingCriteria_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__RatingCriteria_title" }, " 成色评级标准 ", -1)
const _hoisted_4 = { class: "ui__RatingCriteria_content" }
const _hoisted_5 = { class: "ui__RatingCriteria_content_item-title" }
const _hoisted_6 = { class: "condition-value" }
const _hoisted_7 = { class: "ui__RatingCriteria_content_content" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "ui__RatingCriteria_footer" }, " * 成色标准由闲鱼优品制定，合作方286v保障检测项目真实有效 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.qualityList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "ui__RatingCriteria_content_item",
            key: item.qualityLevel
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", {
                class: ["quality-value", {qualityCur: item.qualityLevel.slice(0,1) !== '准'}]
              }, [
                _createVNode("span", null, _toDisplayString(item.qualityLevel.slice(0,1)), 1),
                _createVNode("span", null, _toDisplayString(item.qualityLevel.slice(1)), 1)
              ], 2),
              _createVNode("div", _hoisted_6, " · " + _toDisplayString(item.qualityName), 1)
            ]),
            _createVNode("div", _hoisted_7, _toDisplayString(item.qualityDesc), 1)
          ]))
        }), 128))
      ]),
      _hoisted_8
    ])
  ]))
})